module.exports = __webpack_public_path__ + "static/media/notes.98b409cf.png";